var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1187,
    transform: "translate(-170 -1023)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -929,
    width: 370,
    height: 1061,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -9.47803,
    width: 151.707,
    height: 36.0003,
    rx: 4,
    transform: "rotate(-0.374523 -10 -9.47803)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rect",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13,
    rx: 1.5,
    fill: "none",
    stroke: "#707E8B"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 0.5,
    x2: 5.5,
    y2: 1.5,
    stroke: "#707E8B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 0.5,
    x2: 10.5,
    y2: 1.5,
    stroke: "#707E8B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 1,
    fill: "#707E8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 5,
    r: 1,
    fill: "#707E8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 1,
    fill: "#707E8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1,
    fill: "#707E8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 8,
    r: 1,
    fill: "#707E8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 1,
    fill: "#707E8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: "#707E8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -38,
    y: -931,
    width: 376,
    height: 1067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1187,
    fill: "none",
    transform: "translate(-170 -1023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ea043667eaf0c188c74c52627cbd9dc7.svg";
export { ForwardRef as ReactComponent };